import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetAllEmbalagemResponse } from '../../responses/produto/get-all-embalagem.response';
import { GetEmbalagemResponse } from '../../responses/produto/get-embalagem.response';
import { EmbalagemRequest } from '../../requests/produto/embalagem.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class EmbalagemService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiProduto}embalagem`;

    /**
     * Obtém a lista de Embalagens.
     * Corresponde a: [HttpGet]
     */
    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetAllEmbalagemResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetAllEmbalagemResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui uma embalagem.
     * Corresponde a: [HttpDelete]
     * @param idEmbalagem O ID da embalagem a ser excluída.
     */
    public delete(idEmbalagem: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idEmbalagem}`;

        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Exclui múltiplas embalagens.
     * Corresponde a: [HttpPost/bulk]
     * @param idsEmbalagem Lista de IDs das embalagens a serem excluídas.
     */
    public deleteBulk(idsEmbalagem: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;

        return this.httpClient
            .post<ReturnStruct>(url, { idsEmbalagem }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Obtém uma embalagem por ID.
     * Corresponde a: [HttpGet/:id]
     * @param idEmbalagem O ID da embalagem.
     */
    public getById(idEmbalagem: number): Observable<GetEmbalagemResponse> {
        const url = `${this.apiUrl}/${idEmbalagem}`;

        return this.httpClient
            .get<GetEmbalagemResponse>(url, { ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    /**
     * Cria uma nova embalagem.
     * Corresponde a: [HttpPost]
     * @param request Os dados da embalagem a ser criada.
     */
    public create(request: EmbalagemRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    /**
     * Atualiza uma embalagem existente.
     * Corresponde a: [HttpPut/:id]
     * @param idEmbalagem O ID da embalagem a ser atualizada.
     * @param request Os dados atualizados da embalagem.
     */
    public update(idEmbalagem: number, request: EmbalagemRequest): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/${idEmbalagem}`;

        return this.httpClient
            .put<ReturnStruct>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
